<div class="tw-py-2 tw-max-h-200 tw-bg-white">
	<canvas #doughnutChart></canvas>
</div>